import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';

import { ScheduleCalendarRow } from '../schedule-calendar-jobs/schedule-calendar-jobs.component';

@Component({
  selector: 'app-schedule-details-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './schedule-details-modal.component.html',
  styleUrls: ['./schedule-details-modal.component.css'],
})
export class ScheduleDetailsModalComponent {
  @Input({ required: true }) row!: ScheduleCalendarRow;

  constructor(
    public readonly modal: NgbActiveModal,
    private readonly router: Router,
  ) {}

  formatDateTime(value: string): string {
    if (!value) return '-';

    const date = new Date(value);

    if (Number.isNaN(date.getTime())) {
      return value;
    }

    return new Intl.DateTimeFormat('en-US', {
      timeZone: 'UTC',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    }).format(date);
  }

  getStatusClass(status: string): string {
    switch ((status ?? '').trim().toLowerCase()) {
      case 'cancelled':
      case 'canceled':
        return 'details-status details-status--cancelled';

      case 'failed':
        return 'details-status details-status--failed';

      case 'done':
        return 'details-status details-status--done';

      case 'scheduled':
        return 'details-status details-status--scheduled';

      default:
        return 'details-status';
    }
  }

  reschedule(): void {
    if (!this.row) return;

    this.modal.close({
      action: 'reschedule',
      row: this.row,
    });
  }

  cancel(): void {
    if (!this.row) return;

    this.modal.close({
      action: 'cancel',
      row: this.row,
    });
  }

  navigateToCloneHistoryDetails(): void {
    if (!this.row?.source) return;

    this.modal.dismiss();

    this.router.navigate([
      'clone-history-details',
      this.row.source,
    ]);
  }
}